import { hotTopics } from "@/mocks/gossipData";
import { SectionHead } from "./ui";

export default function Topics() {
  return (
    <section id="topic" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <SectionHead
          index="05"
          kicker="热议话题 · 大家都在聊"
          title="一个话题，一群人的心声"
          desc="点开即达相关讨论。以下是近期讨论度最高的校园圈议题，也欢迎你补充下一个。"
          tone="secondary"
        />
        <div className="flex flex-wrap gap-2.5">
          {hotTopics.map((tp, i) => {
            const tone = i % 4 === 0 ? "primary" : i % 4 === 1 ? "accent" : i % 4 === 2 ? "secondary" : "plain";
            return (
              <a
                key={tp}
                href="#heat"
                className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition hover:-translate-y-0.5 ${
                  tone === "primary"
                    ? "border-primary-200 bg-primary-50 text-primary-800 hover:bg-primary-100"
                    : tone === "accent"
                      ? "border-accent-200 bg-accent-50 text-accent-900 hover:bg-accent-100"
                      : tone === "secondary"
                        ? "border-secondary-200 bg-secondary-50 text-secondary-900 hover:bg-secondary-100"
                        : "border-background-200 bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                <i className="ri-hashtag text-xs opacity-70"></i>
                {tp}
              </a>
            );
          })}
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100/60 px-4 py-3 text-sm text-foreground-600">
          <span className="inline-flex items-center gap-1.5 font-semibold text-foreground-800">
            <i className="ri-lightbulb-flash-line text-accent-500"></i>
            还没人聊的角落
          </span>
          你有没有见过那种「没人敢说，但大家都知道」的事？
          <a href="#report" className="inline-flex items-center gap-1 font-bold text-primary-600 hover:text-primary-700">
            投个稿 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}